import { Box, Card, CardActionArea, Grid, Typography, useTheme } from '@mui/material'

import ControlPointIcon from '@mui/icons-material/ControlPoint'

import { HelperWrapper } from 'src/components/helper-wrapper'
import { useStyles } from './styles'

interface IAccountAddNewCardProps {
  handleAdditionClick: () => void
  additionalText?: string
}

const AccountAddNewCard = ({ handleAdditionClick, additionalText }: IAccountAddNewCardProps) => {
  const theme = useTheme()
  const classes = useStyles()

  return (
    <Grid item>
      <Card className={classes.addNewCardWrapper}>
        <CardActionArea className={classes.addNewCard} onClick={handleAdditionClick}>
          <div className={classes.addNewCardAction}>
            <ControlPointIcon sx={{ color: theme.palette.custom.primary }} />
            <Typography className={classes.addNewCardText}>
              <HelperWrapper t="button-add-new-text" />
            </Typography>
          </div>
          {additionalText && (
            <Typography className={classes.addNewCardTextSecondary}>
              <HelperWrapper t={additionalText} />
            </Typography>
          )}
        </CardActionArea>
      </Card>
    </Grid>
  )
}

export { AccountAddNewCard }
